module.exports = __webpack_public_path__ + "static/media/verified.f2ad61da.svg";